import { Button } from "@/components/ui/button";
import { Mail } from "lucide-react";
import { toast } from "@/hooks/use-toast";
import { formatPriceDisplay } from '@/utils/currency';
import { logAdminEvent } from "@/utils/auditLog";

interface EmailShareProps {
  property: any;
  recipientEmail: string;
  recipientName: string;
  variant?: "default" | "outline";
  size?: "sm" | "default";
}

export const EmailShare = ({ property, recipientEmail, recipientName, variant = "default", size = "default" }: EmailShareProps) => {

  const handleEmailShare = async () => {
    const subject = `Property Details: ${property.title}`;
    const body = `Dear ${recipientName},

Here are the details of the property you inquired about:

Property: ${property.title}
Location: ${property.location}, ${property.city}
Price: ${formatPriceDisplay({ price: property.price })}
Type: ${property.property_type.replace('_', ' ')}
${property.area_sqft ? `Area: ${property.area_sqft} sq ft` : ''}
${property.bedrooms ? `Bedrooms: ${property.bedrooms}` : ''}

${property.description ? `Description: ${property.description}` : ''}

Please let us know if you need more information or would like to schedule a visit.

Best regards,
Real Estate Team`;

    const mailtoUrl = `mailto:${recipientEmail}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    window.open(mailtoUrl);

    void logAdminEvent("email_share", {
      resourceType: "property",
      resourceId: property?.id ?? null,
      details: {
        property_title: property?.title ?? null,
        recipient_email: recipientEmail || null,
        recipient_name: recipientName || null,
        channel: "mailto",
      },
    });

    toast({
      title: "Email Client Opened",
      description: "Email template opened in your default email client",
    });
  };

  return (
    <Button
      onClick={handleEmailShare}
      variant={variant}
      size={size}
      className="w-full"
      aria-label="Share via email"
    >
      <Mail className="h-4 w-4" />
    </Button>
  );
};